var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"highlight-row":"","row-key":"id","columns":_vm.columns,"data":_vm.list},on:{"on-row-click":_vm.handleOnRowClick},scopedSlots:_vm._u([_vm._l((_vm.columns),function(item,i){return {key:item.slot,fn:function(ref){
var row = ref.row;
var index = ref.index;
return (item.slot)?[_vm._t(item.slot,null,{"data":{ row: row, index: index }})]:undefined}}})],null,true)}),_vm._v(" "),_c('div',{staticClass:"mg-bottom20"}),_vm._v(" "),(_vm.showPage)?_c('Page',{attrs:{"current":_vm.search.page,"total":_vm.total},on:{"on-change":_vm.getLoad}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64adacd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myTable.vue
// module id = null
// module chunks = 